Bingo.DemandFormRoomSwitch = {};

Bingo.DemandFormRoomSwitch.init = function () {
    Bingo.DemandFormRoomSwitch.hideCheckBoxes();
    $('#frm-demandFirstStepForm-form [name="mode"]').click(() => {
        Bingo.DemandFormRoomSwitch.hideCheckBoxes();
    });
};

Bingo.DemandFormRoomSwitch.hideCheckBoxes = function () {
    const $modeVal = $('#frm-demandFirstStepForm-form [name="mode"]:checked').val();
    const $typeVal = $('#frm-demandFirstStepForm-form [name="type"]:checked').val();
    const $typeObj = $('#frm-demandFirstStepForm-form [name="type"]');
    if (parseInt($modeVal) === 1) {
        $typeObj.each(function () {
            if ($(this).val() > 100) {
                if ($typeVal === $(this).val()) {
                    $(this).prop('checked', false);
                }
                $(this).closest('.radio').hide();
            }
        });
    } else {
        $typeObj.each(function () {
            if ($(this).val() > 100) {
                $(this).closest('.radio').show();
            }
        });
    }
};
